export default function(instance) {
    return {
        getAllNews(data) {
			return instance.get('/api/news/admin/',
			{
				params: data ? data : ''
			});
		},
		createNewNews(data) {
			return instance.post('/api/news/admin/', { title: data.title, body: data.body });
		},
		getOneNews(idNews) {
			return instance.get(`/api/news/admin/${idNews}/`)
		},
		updateOneNews(idNews, data) {
			return instance.put(`/api/news/admin/${idNews}/`, { title: data.title, body: data.body });
		},
		deleteNews(idNews) {
			return instance.delete(`/api/news/admin/${idNews}/`)
		},

		updateNewsImage(id, data) {
			let formData = new FormData();
			formData.append('image', data.imageFile);

			return instance.post(`/api/news/admin/image/${id}/`, formData, {
				headers: {
				  'Content-Type': 'multipart/form-data'
				}
			});
		}
    }
}